<template>
  <!-- banner -->
  <section v-if="solucao != ''" class="hero-wrap hero-wrap-2" :style="{ backgroundImage: 'url(' + $imgURL + solucao.insInstitucionalImagens.filter(x=> x.insListaGaleriaInstImagens.lgiId == 27)[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="col-md-9 pb-5">
          <h1 class="mb-0 bread">{{ solucao.itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- empresa -->
  <section v-if="solucao !=''" class="ftco-section ftco-about ftco-no-pt ftco-no-pb img">
    <div class="container">
      <div class="row d-flex">
        <div class="col-md-12 about-intro">
          <div class="row d-flex">
            <div class="col-md-6 d-flex align-items-stretch">
              <div class="img d-flex align-items-center align-self-stretch justify-content-center"
                :style="{ backgroundImage: 'url(' + $imgURL + solucao.insInstitucionalImagens.filter(x=> x.insListaGaleriaInstImagens.lgiId == 28)[0].itgUrlImagem + ')' }">
              </div>
            </div>
            <div class="col-md-6 pl-md-5 py-5">
              <div class="row justify-content-start pb-3 pt-md-5">
                <div class="col-md-12 heading-section ">
                  <span class="subheading">{{ solucao.itiNome }}</span>
                  <h2 class="mb-4">{{ solucao.itiReferencia }}</h2>
                  <p v-html="solucao.itiResumo1"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END empresa -->

  <!-- video -->
  <section v-if="solucao !='' && (solucao.itiCampoExtra1 !='' && solucao.itiCampoExtra1 !=null)"  class="video-section">
    <iframe :src="solucao.itiCampoExtra1" style="margin-top: 100px; margin-bottom: 100px;"
      title="YouTube video player" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  </section>
  <!-- END video -->

  <!-- produtos -->
  <section
  v-if="solucao && solucao.insInstitucionalImagens && solucao.insInstitucionalImagens.filter(x => x.insListaGaleriaInstImagens?.lgiId == 29).length > 0"
  class="ftco-section ftco-portfolio bg-light"
>
  <div class="overlay"></div>
  <div class="container">
    <div class="row justify-content-between pb-5">
      <div class="col-md-6 col-lg-6 heading-section heading-section-white ">
        <span class="subheading">{{ solucao.itiCampoExtra2 }}</span>
        <h2 class="mb-4">{{ solucao.itiCampoExtra3 }}</h2>
      </div>
    </div>
    <div class="row">
      <div
        v-for="(produto, index) in solucao.insInstitucionalImagens.filter(x => x.insListaGaleriaInstImagens?.lgiId == 29)"
        :key="index"
        class="col-md-3"
      >
        <div
          v-if="produto?.itgUrlImagem"
          class="project-wrap img d-flex"
          :style="{ backgroundImage: 'url(' + $imgURL + produto.itgUrlImagem + ')' }"
        >
          <div class="text">
            <h3>{{ produto.itgNome }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  <!-- END produtos -->

   <PageCallAction></PageCallAction>
</template>

<script>
import PageCallAction from '@/components/PageCallAction.vue';
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'SolucaoTecnicaView',
  components: {
    PageCallAction,

  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    
    solucao: [],
    produtos: [],

  }),

  methods: {

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Soluções - Performance Elevadores - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

  },

  created() {
    
      //aqui busca página detalhe
      axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.solucao = response.data;
        this.carregaMetas(this.removerTagsHTML(this.solucao.itiDescricao1), this.solucao.itiNome);
        console.log('página detalhe')
        console.log(this.solucao)
      })
      .catch(error => {
        console.error(error);
      });
      
  },
}
</script>

<style scoped></style>